
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Coins, Video, Layers, Users, Shield, Zap } from 'lucide-react';

export default function AboutPage() {
  return (
    <div className="container-custom py-12">
      <div className="max-w-4xl mx-auto mb-16 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-6">About FTTF.World</h1>
        <p className="text-xl text-gray-400">
          A decentralized platform for creators to stream, mint NFTs, and connect with their audience
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-20">
        <div>
          <h2 className="text-3xl font-bold mb-6">Our Mission</h2>
          <p className="text-lg text-gray-300 mb-6">
            FTTF.World is built to empower creators with the tools they need to monetize their content
            and build meaningful connections with their audience in a decentralized ecosystem.
          </p>
          <p className="text-lg text-gray-300">
            We believe in a future where creators have full ownership of their content, direct
            relationships with their fans, and multiple revenue streams that aren't controlled by
            centralized platforms.
          </p>
        </div>
        <div className="bg-dark-800 rounded-2xl overflow-hidden">
          <img 
            src="https://images.unsplash.com/photo-1633356122544-f134324a6cee?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" 
            alt="FTTF.World Platform" 
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      <div className="mb-20">
        <h2 className="text-3xl font-bold mb-10 text-center">Key Features</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Card className="bg-dark-800 border-dark-700">
            <CardContent className="p-6">
              <div className="mb-4 text-primary-500">
                <Video size={36} />
              </div>
              <h3 className="text-xl font-bold mb-2">Live Streaming</h3>
              <p className="text-gray-400">
                Stream your content live to your audience with low latency and high quality using Livepeer's decentralized video infrastructure.
              </p>
            </CardContent>
          </Card>
          
          <Card className="bg-dark-800 border-dark-700">
            <CardContent className="p-6">
              <div className="mb-4 text-primary-500">
                <Layers size={36} />
              </div>
              <h3 className="text-xl font-bold mb-2">NFT Marketplace</h3>
              <p className="text-gray-400">
                Create, sell, and collect NFTs that represent digital art, stream highlights, or exclusive content for your community.
              </p>
            </CardContent>
          </Card>
          
          <Card className="bg-dark-800 border-dark-700">
            <CardContent className="p-6">
              <div className="mb-4 text-primary-500">
                <Coins size={36} />
              </div>
              <h3 className="text-xl font-bold mb-2">Creator Economy</h3>
              <p className="text-gray-400">
                Multiple revenue streams including tips, NFT sales, token-gated content, and subscription models using DUSD tokens.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>

      <div className="mb-20">
        <h2 className="text-3xl font-bold mb-10 text-center">Why Choose FTTF.World?</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="flex">
            <div className="mr-4 text-primary-500">
              <Users size={24} />
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">Community First</h3>
              <p className="text-gray-400">
                We're building a platform that puts creators and their communities at the center, not advertisers or algorithms.
              </p>
            </div>
          </div>
          
          <div className="flex">
            <div className="mr-4 text-primary-500">
              <Shield size={24} />
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">True Ownership</h3>
              <p className="text-gray-400">
                Your content, your audience, your revenue - all secured by blockchain technology.
              </p>
            </div>
          </div>
          
          <div className="flex">
            <div className="mr-4 text-primary-500">
              <Zap size={24} />
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">Low Fees</h3>
              <p className="text-gray-400">
                We take minimal platform fees so creators keep more of what they earn.
              </p>
            </div>
          </div>
          
          <div className="flex">
            <div className="mr-4 text-primary-500">
              <Coins size={24} />
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">DUSD Ecosystem</h3>
              <p className="text-gray-400">
                Our platform token DUSD powers all transactions with stable value and low gas fees.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-dark-800 rounded-2xl p-8 text-center">
        <h2 className="text-3xl font-bold mb-4">Ready to join the future of content creation?</h2>
        <p className="text-xl text-gray-400 mb-6">
          Start creating, streaming, and connecting with your audience today.
        </p>
        <button className="btn-primary px-8 py-3 text-lg">
          Get Started
        </button>
      </div>
    </div>
  );
}
